import React from 'react'
import { compose, withState } from 'recompose'
import { withCanvasActions } from 'store/canvas/hocsCanvas'
import { Dialog, FlatButton, RaisedButton } from 'material-ui'
import { Button } from 'semantic-ui-react'
import EnlargeButton from '../components/EnlargeButton'
import Tabs from 'components/Tabs/CustomTabs'
import GeneralElements from '../selectors/GeneralElements'
import StoreTemplates from '../selectors/StoreTemplates'

const ElementSelector = compose(
  withCanvasActions(),
  withState('currentItem', 'setCurrentItem', null),
  withState('currentTab', 'setCurrentTab', 'storeTemplates'),
)(
  ({
    currentItem,
    setCurrentItem,
    openSelector,
    closeSelector,
    isOpened,
    onCreateElement,
    onAddTemplate,
    emptyMode,
    currentTab,
    setCurrentTab,
    zIndex,
  }) => {
    const actions = [
      <FlatButton
        label="Cancel"
        onTouchTap={closeSelector}
        primary={true}
      />,
      <RaisedButton
        label="Submit"
        primary={true}
        onTouchTap={() => {
          if(currentItem){
            if(currentTab === 'elements'){
              return onCreateElement(currentItem)
            }
            // case add template
            return onAddTemplate(currentItem)
          }
        }}
      />,
    ]
    return (
      <div
        className="element-selector"
        style={{
          position: 'relative',
          zIndex,
          ...emptyMode && {
            padding: 8,
            height: '100%',
          }
        }}
      >
        {emptyMode ?
          <div
            style={{
              minHeight: 200,
              height: '100%',
              borderStyle: 'dashed',
              borderWidth: 1,
              borderColor: '#b9b9b9',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Button icon="plus" size="large" circular onClick={openSelector} />
          </div>
          :
          <EnlargeButton onClick={openSelector} />
        }
        <Dialog
          open={isOpened}
          actions={actions}
          title="Select an item"
          autoScrollBodyContent={true}
          autoDetectWindowHeight={true}
          repositionOnUpdate={true}
          contentStyle={{ maxWidth: 1100, minWidth: 1100 }}
          bodyStyle={{ minHeight: 400 }}
        >
          <Tabs
            style={{ maxHeight: 500 }}
            defaultTabValue={currentTab}
            onTouchTab={setCurrentTab}
          >
            <StoreTemplates
              tabLabel="Store Templates"
              tabValue="storeTemplates"
              currentTemplate={currentItem}
              onSelectTemplate={setCurrentItem}
            />
            <GeneralElements
              tabLabel="Elements"
              tabValue="elements"
              currentElement={currentItem}
              onSelectElement={setCurrentItem}
            />
          </Tabs>
        </Dialog>
      </div>
    )
  }
)

ElementSelector.propTypes = {}
ElementSelector.defaultProps = {}

export default ElementSelector



// WEBPACK FOOTER //
// ./src/components/Canvas/builder/core/ElementSelector.js